export default "__VITE_ASSET__sWGfQTOr__"